import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pages/")({
  component: lazyRouteComponent(() => import("./-pages/admin.pages.index")),
  head: () => ({ meta: [{ title: "الصفحات · Admin · Lecmo" }] }),
});
